import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT_MODEM_MODELS = "modem-models";

const currentUserPayload = () => ({
  currentUserId: store.state.currentUser?.uid,
});

const ModemModelsService = {
  findAll: async () =>
    apiService.get(ENDPOINT_MODEM_MODELS, {
      params: currentUserPayload(),
    }),

  create: async (modemModel) =>
    apiService.post(ENDPOINT_MODEM_MODELS, {
      ...currentUserPayload(),
      modemModel,
    }),

  update: async (id, modemModel) =>
    apiService.put(`${ENDPOINT_MODEM_MODELS}/${id}`, {
      ...currentUserPayload(),
      modemModel,
    }),

  remove: async (id) =>
    apiService.delete(`${ENDPOINT_MODEM_MODELS}/${id}`, {
      data: currentUserPayload(),
    }),
};

export default ModemModelsService;
